import { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { MODALS_ENUM } from "@constants/Modals";
import Title from "@components/global/new/Title/Title";
import Button from "@components/global/new/Button/Button";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { ReactComponent as CloseIcon } from "@assets/icons/close.svg";

export interface ErrorModalExposedPropsI {
  title?: string;
  subtitle?: string;
  onConfirm(): void;
}

interface ErrorModalPropsI
  extends CommonModalPropsI,
    ErrorModalExposedPropsI {}

function ErrorModal({
  title,

  handleClose,
  onConfirm,
  formatMessage,
  ...props
}: ErrorModalPropsI) {
  const { ok } = makeNotifs();
  const onConfirmHandler = () => {
    onConfirm();
    handleClose();
  };

  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (ref.current && ref.current.parentElement) {
      ref.current.parentElement.style.width = "380px";
    }
  }, [ref]);

  return (
    <div className={styles.wrapper} ref={ref}>
      <div className={styles.title_wrapper}>
        <Title className={styles.title}>
          {title || formatMessage({ id: "modal.error.title" })}
        </Title>
        <CloseIcon className={styles.close} onClick={handleClose} />
      </div>
      {props.subtitle && (
        <Title className={styles.subtitle}>{props.subtitle}</Title>
      )}

      <div className={styles.btns}>
        <Button onClick={onConfirmHandler}>
          {formatMessage({ id: "modal.error.btn.ok" })}
        </Button>
      </div>
    </div>
  );
}

export default WithModal(MODALS_ENUM.ERROR_MODAL, ErrorModal, {
  style: { padding: 0 },
  hideIcon: true,
});
